import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import GlobalHeader from "@/components/GlobalHeader";
import Footer from "@/components/Footer";
import { usePageSEO } from "@/hooks/use-page-seo";
import { ArrowRight } from "lucide-react";

const MusicGivingHope = () => {
  usePageSEO({
    title: "Thank You — Yacht Rock Detroit Unplugged",
    description:
      "Yacht Rock Detroit Unplugged, the Music Giving Hope charity gala benefiting the Detroit Youth Choir, took place July 16, 2026 at The Roostertail. Thank you for an amazing evening.",
    canonical: "https://yachtrockdetroit.com/music-giving-hope",
    breadcrumbs: [
      { name: "Home", url: "https://yachtrockdetroit.com/" },
      { name: "Music Giving Hope", url: "https://yachtrockdetroit.com/music-giving-hope" },
    ],
  });

  return (
    <main className="min-h-screen bg-yacht-deepteal flex flex-col">
      <GlobalHeader />

      <section className="flex-1 flex items-center justify-center px-6 py-32 md:py-40">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-2xl mx-auto"
        >
          <p className="text-yacht-cream/70 text-[11px] md:text-xs font-bold uppercase tracking-[0.25em] mb-6">
            Yacht Rock Detroit Unplugged · July 16, 2026
          </p>
          <h1 className="text-white text-5xl md:text-7xl font-bold leading-[1.05] tracking-tight mb-4">
            That was amazing.
          </h1>
          <p
            className="text-yacht-cream text-2xl md:text-4xl italic leading-snug mb-10"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
          >
            See you tomorrow.
          </p>
          <Link
            to="/tickets"
            className="inline-flex items-center gap-2 text-yacht-yellow font-bold text-sm md:text-base uppercase tracking-wide hover:gap-3 transition-all"
          >
            Festival Tickets
            <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      </section>

      <Footer />
    </main>
  );
};

export default MusicGivingHope;
